import React, { Component } from 'react';
import SquareBorderButton from '@lyearn-team/frontend-components/dist/Button/SquareBorderButton';
import ActivityIndicator from '@lyearn-team/frontend-components/dist/Loader';
import SearchInput from '@lyearn-team/frontend-components/dist/Input/SearchInput';
import Icon from '@lyearn-team/frontend-components/dist/Icon';
import globalURL from 'helper/url';
import {
  SuccessMessage,
  SuccessCircle,
  ForgotPasswordHeading,
  ForgotPasswordInnerText,
  ForgotPasswordSearchInputWrapper,
  ForgotPasswordSquareBorderButtonWrapper,
  buttonClass
} from './styles';
import { validateEmail } from '../shared/static';
import { EmailStatus } from '../shared/consts';

class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      emailAddress: '',
      emailErrorStatus: '',
      loading: false,
      success: false
    };
  }

  onFocusInput() {
    if (window.bowser.mobile) {
      document.body.style.height = '1000px';
      document.body.style.overflow = 'hidden';
      window.scrollTo(0, 100);
    }
  }

  onFocusOut() {
    document.body.style.height = '100%';
    window.scrollTo(0, 0);
  }

  onEmailAddressChange = (e) => {
    if (e.target.value && this.state.emailErrorStatus) {
      this.setState({ emailErrorStatus: '' });
    }
    this.setState({ emailAddress: e.target.value });
  };

  onKeyDown = (e) => {
    if (e.keyCode === 13) {
      this.sendEmail();
    }
  };

  send = (params, requestURL) => {
    fetch(requestURL, {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: params
    })
      .then(response => response.json())
      .then((response) => {
        this.setState({ loading: false });
        if (!response.error) {
          this.setState({ success: true });
        } else {
          this.setState({ emailErrorStatus: EmailStatus.CAN_NOT_FIND });
        }
      })
      .catch((error) => {
        console.log('Error is', error);
        this.setState({ loading: false });
      });
  };

  sendEmail = () => {
    const email = this.userEmail.props.value;
    const { companySubDomain } = this.props;
    let params = '';
    let requestURL = '';
    if (!email) {
      this.setState({ emailErrorStatus: EmailStatus.BLANK_EMAIL });
      return;
    }
    if (!validateEmail(email)) {
      this.setState({ emailErrorStatus: EmailStatus.EMAIL_NOT_VALID });
      return;
    }
    this.setState({ loading: true });
    params = JSON.stringify({ userName: email.toLowerCase() });
    requestURL = globalURL.awsEndpoint + `/forgotPassword?cn=${companySubDomain}`;
    this.send(params, requestURL);
  };

  renderActivityIndicator = () => (
    <ActivityIndicator
      svgColor="#fff"
      style={{ marginRight: '6px', fill: '#fff' }}
      width={16}
      height={16}
    />
  );

  render() {
    const { emailAddress, emailErrorStatus, loading, success } = this.state;
    const { companySubDomain } = this.props;
    let icon = '';
    let errorMessage = '';
    if (emailErrorStatus === EmailStatus.BLANK_EMAIL) {
      errorMessage = 'Please enter email';
    } else if (emailErrorStatus === EmailStatus.EMAIL_NOT_VALID) {
      errorMessage = 'Please enter valid email';
    }
    if (loading) {
      icon = this.renderActivityIndicator();
    }
    if (success) {
      return (
        <SuccessMessage>
          <SuccessCircle>
            <Icon type="check" />
          </SuccessCircle>
          An email has been sent to&nbsp;
          <strong>{this.userEmail && this.userEmail.props.value}</strong>
        </SuccessMessage>
      );
    }

    return (
      <div>
        {/* {window.bowser.mobile ? <FixMargin /> : ''} */}
        <ForgotPasswordHeading>Forgot Password</ForgotPasswordHeading>
        <ForgotPasswordInnerText>
          To reset your password, enter the email address you use to sign in to
          {' '}
          <strong>
            {companySubDomain}
            .lyearn.com.
          </strong>
        </ForgotPasswordInnerText>
        <ForgotPasswordSearchInputWrapper>
          <SearchInput
            ref={component => !!component && (this.userEmail = component)}
            placeholder="Email address"
            value={emailAddress}
            onChange={this.onEmailAddressChange}
            onKeyDown={this.onKeyDown}
            showSearchIcon={false}
            error={errorMessage}
            onFocus={this.onFocusInput}
            onBlur={this.onFocusOut}
          />
        </ForgotPasswordSearchInputWrapper>
        <ForgotPasswordSquareBorderButtonWrapper>
          <SquareBorderButton
            className={buttonClass}
            text={loading ? 'Sending Email' : 'Send email'}
            icon={icon}
            onClick={this.sendEmail}
            type="filled"
            disabled={loading}
            iconPosition="left"
          />
        </ForgotPasswordSquareBorderButtonWrapper>
      </div>
    );
  }
}

export default ForgotPassword;
